import React from 'react';
import SiteContentEditor from './SiteContentEditor';

const SiteContentPage = ({ onShowToast }) => {
    return <SiteContentEditor onShowToast={onShowToast} />;
};

export default SiteContentPage;
